import moment from "moment";

const nestCustomFields = (flatObj) => {
  const nested = {};

  for (const [key, value] of Object.entries(flatObj)) {
    const [main, rest] = key.split(/_(.+)/);

    if (!rest) {
      nested[main] = value;
      continue;
    }

    nested[main] = nested[main] || {};
    nested[main][rest] = value;
  }

  return nested;
};

const extractCustomBusinessFields = (record) => {
  if (!record) return {};

  const customBusinessFields = {};

  Object.keys(record).forEach((key) => {
    if (key.startsWith("customBusinessFields_")) {
      customBusinessFields[key] = record[key];
    }
  });

  return customBusinessFields;
};
const formatDateToISO = (dateValue) => {
  return dateValue
    ? moment.utc(dateValue).startOf("day").toISOString()
    : undefined;
};
const convertFieldsToIso = (record, fields = []) => {
  if (!record) return record;

  const result = { ...record };
  fields.forEach((key) => {
    if (result[key]) {
      result[key] = formatDateToISO(result[key]);
    }
  });

  return result;
};
const convertFieldsToDate = (record, fields = []) => {
  if (!record) return record;

  const result = { ...record };
  fields.forEach((key) => {
    if (result[key]) {
      result[key] = moment.utc(result[key]).format("YYYY-MM-DD");
    }
  });

  return result;
};
const processCustomBusinessDateFields = (
  customBusinessFields,
  dateFields = []
) => {
  if (!customBusinessFields) {
    return customBusinessFields;
  }

  const processedFields = { ...customBusinessFields };
  Object.keys(processedFields).forEach((key) => {
    if (
      (key.startsWith("cdf") || dateFields.includes(key)) &&
      processedFields[key]
    ) {
      processedFields[key] = formatDateToISO(processedFields[key]);
    }
  });

  return processedFields;
};

const processCdfFields = (record, type = "toIso") => {
  if (!record) return record;

  const fieldsToProcess = Object.keys(record).filter(key => key.includes("_cdf"));

  switch (type) {
    case "toIso":
      return convertFieldsToIso(record, fieldsToProcess);
    case "toDate":
      return convertFieldsToDate(record, fieldsToProcess);
    default:
      throw new Error("Invalid type. Use 'toIso' or 'toDate'.");
  }
};

const util = {
  nestCustomFields,
  extractCustomBusinessFields,
  processCustomBusinessDateFields,
  convertFieldsToIso,
  convertFieldsToDate,
  processCdfFields,
  formatDateToISO
};
export default util;
